import { CustomBottomBar } from '@components';
import { Button, Checkbox, Container, Dropdown, Textarea, Typography } from '@design-system';
import SignatureCanvas from 'react-signature-canvas';
import './HomeSecurityEmargement.scss';
import { useHomeSecurityEmargementVM } from './useHomeSecurityEmargementVM';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { CreateHomeSecurityPayload } from '@services/homeSecurity/homeSecurity.types';
import { UserDropdown } from '@components/UserDropdown/UserDropDown';

export const HomeSecurityEmargement: React.FC = () => {
    const {
        signatureCanvasRef,
        handleClearSignature,
        setIsSignatureEmpty,
        handleSaveSignature,
        selectedUser,
        setSelectedUser,
        isMinor,
        setIsMinor,
        hasFilledInfos,
        contractType,
        setContractType,
        isInformationChecked,
        setIsInformationChecked,
        isEpiChecked,
        setIsEpiChecked,
        comment,
        setComment
    } = useHomeSecurityEmargementVM();

    return (
        <div className="home-security">
            <Container>
                <Container bordered="grey" className="signature-container">
                    <Typography intrinsic="h3" defaultSpacing>
                        Personne accueillie
                    </Typography>
                    {/* <Input
                        placeholder="Nom de la personne"
                        value={selectedUser ?? ''}
                        onValueChange={(value: string) => setSelectedUser(value)}
                        className="mb-small-spacing"
                    /> */}
                    <UserDropdown onChangeAction={(userId: string) => setSelectedUser(userId)} value={selectedUser} valueKey="label" canCreate />
                    <Dropdown
                        options={[
                            { id: 'CDI', label: 'CDI' },
                            { id: 'CDD', label: 'CDD' },
                            { id: 'INTERIM', label: 'INTERIM' },
                            { id: 'STAGE', label: 'STAGE' }
                        ]}
                        placeholder="Type de contrat"
                        value={contractType ? { id: contractType, label: contractType } : null}
                        onOptionChange={(option) => setContractType(option.id as CreateHomeSecurityPayload['contract_type'])}
                    />
                    <Checkbox
                        className="mt-medium-spacing"
                        label="Cette personne est mineure"
                        checked={isMinor}
                        onChange={(isChecked) => {
                            setIsMinor(isChecked as boolean);
                        }}
                    />

                    <Checkbox
                        className="mt-medium-spacing"
                        label="Les informations et consignes m'ont été présentées et j'ai reçu les informations nécessaires pour assurer ma protection sur le chantier/atelier. Je m'engage à prendre soin de ma sécurité et de celle des autres et à signaler tout risque ou dysfonctionnement en matière de sécurité"
                        checked={isInformationChecked}
                        onChange={(isChecked) => {
                            setIsInformationChecked(isChecked as boolean);
                        }}
                    />

                    <Checkbox
                        className="mt-medium-spacing"
                        label="Les consignes d'utilisation des EPI m'ont été présentées et j'ai reçu les informations nécessaires pour assurer ma protection. Je m'engage à les porter, à en prendre soin et à signaler tout défaut ou dysfonctionnement. J'atteste avoir fait la formation générale à la sécurité sur le lieu et poste de travail en fonction des éléments ci-dessus"
                        checked={isEpiChecked}
                        onChange={(isChecked) => {
                            setIsEpiChecked(isChecked as boolean);
                        }}
                    />

                    <Textarea
                        placeholder="Consignes particulières"
                        value={comment}
                        onValueChange={(value: string) => setComment(value)}
                        className="mt-medium-spacing"
                    />

                    <Typography intrinsic="h4" className="mt-medium-spacing">
                        Signature obligatoire pour valider l'accueil
                    </Typography>
                    <Container padding="none" className="signature-grow">
                        <SignatureCanvas
                            throttle={24}
                            velocityFilterWeight={1}
                            penColor="black"
                            canvasProps={{
                                className: 'sigCanvas'
                            }}
                            onEnd={() => setIsSignatureEmpty(false)}
                            ref={signatureCanvasRef}
                        />
                        <div className="buttons">
                            <Button
                                icon={<RiArrowGoBackLine />}
                                iconSize={25}
                                onClick={handleClearSignature}
                                iconColor="green"
                                variant="secondary"
                                color="green"
                                className="refresh-signature-button"
                            >
                                <></>
                            </Button>
                        </div>
                    </Container>
                </Container>
            </Container>

            <CustomBottomBar>
                <Button variant="primary" color="marine" size="fullwidth" disabled={!hasFilledInfos} onClick={handleSaveSignature}>
                    <Typography intrinsic="h4">Étape suivante</Typography>
                </Button>
            </CustomBottomBar>
        </div>
    );
};
